import { type ReactNode, useEffect } from "react";
import { useLocalizationStore } from "@/stores/localization-store/localization-store";
import type { LocalizationStore } from "@/stores/localization-store/localization-store.types";
import type { SharedDataLocalization } from "@/types";

type LocalizationProviderProps = {
  localization: SharedDataLocalization;
  children: ReactNode;
};

export const LocalizationProvider = ({
  localization,
  children,
}: LocalizationProviderProps) => {
  const storeLocalizationValues = useLocalizationStore(
    (state: LocalizationStore) => state.storeLocalizationValues
  );
  const localizationLoading = useLocalizationStore(
    (state: LocalizationStore) => state.localizationLoading
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: Would cause endless re-renders
  useEffect(() => {
    const handleLocation = async () => {
      await storeLocalizationValues(localization);
    };

    handleLocation();
  }, [localization?.language]);

  if (localizationLoading) {
    return null;
  }

  return children;
};
